import React from "react";
import { useSelector } from "react-redux";
import { DefaultUIConfigs } from "../../redux/reducers/ui-config/UiConfig";
import { AppState } from "../../redux/store";

const BlockUiOverlay: React.FC = () => {
  const blockUiInput = useSelector((state: AppState) => 
    state.uiConfig.general[DefaultUIConfigs.BLOCK_UI_INPUT]
  );

  return (
    <div
      style={{
        zIndex: 99999,
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        pointerEvents: blockUiInput ? "all" : "none",
      }}
    />
  );
};

export default BlockUiOverlay;
